import { getAuthContext } from '../context/AuthContext';

const getAxios = () => getAuthContext().axiosInstance;

export const AlmacenService = {
    getBySucursal: async (idSucursal) => {
        const response = await getAxios().get(`/api/almacenes/sucursal/${idSucursal}`);
        return response.data;
    },
    
    getByVariante: async (idVariante) => {
        const response = await getAxios().get(`/api/almacenes/variante/${idVariante}`);
        return response.data;
    },
    
    getById: async (id) => {
        const response = await getAxios().get(`/api/almacenes/${id}`);
        return response.data;
    },

    create: async (almacen) => {
        const response = await getAxios().post('/api/almacenes', almacen);
        return response.data;
    },

    update: async (id, almacen) => {
        const response = await getAxios().put(`/api/almacenes/${id}`, almacen);
        return response.data;
    },

    delete: async (id) => {
        const response = await getAxios().delete(`/api/almacenes/${id}`);
        return response.data;
    }
};
